import { Component, Injector, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'funds-initial-payment-form',
    templateUrl: './funds-initial-payment-form.component.html',
    styleUrls: ['./funds-initial-payment-form.component.scss'],
    standalone: false
})
export class FundsInitialPaymentFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
  ) {
    super(formConstructor, injector);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
